<template>
    <div class="qr-code d-flex justify-content-center align-items-center">
        <canvas :id="'qr-code-canvas-' + this.id" class="qr-code-canvas"></canvas>
    </div>
</template>

<script>

import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'
import qrcode from 'qrcode'

export default Vue.extend({
    data() {
        return {
            id: undefined,
            code: undefined,
            canvas: undefined,
        }
    },
    props: {
        value: {
            default: '',
            type: String
        },
    },
    created() {
        this.id = uuidv4()
    },
    mounted() {
        this.canvas = document.getElementById(`qr-code-canvas-${this.id}`)
        this.canvas.style.width = '150px'
        this.canvas.style.height = '150px'
        qrcode.toCanvas(this.canvas, this.value)
    }
})
</script>